// localStorage key for persisting the viewing month filter
const VIEWING_MONTH_KEY = "payment-tracking-viewing-month";

export type ViewingPeriod = { month: number; year: number };

/**
 * Loads the viewing period from localStorage with validation
 */
export const loadViewingPeriod = (): ViewingPeriod => {
  try {
    const saved = localStorage.getItem(VIEWING_MONTH_KEY);
    if (saved) {
      const parsed = JSON.parse(saved);
      // Validate the saved data
      if (
        parsed &&
        typeof parsed.month === "number" &&
        typeof parsed.year === "number" &&
        parsed.month >= 0 &&
        parsed.month <= 11
      ) {
        return parsed;
      }
    }
  } catch (error) {
    console.warn("Failed to load viewing period from localStorage:", error);
  }

  // Default to current month if no valid saved data (use UTC to avoid TZ drift in tests)
  const now = new Date();
  return { month: now.getUTCMonth(), year: now.getUTCFullYear() };
};

/**
 * Saves the viewing period to localStorage
 */
export const saveViewingPeriod = (period: ViewingPeriod): void => {
  try {
    localStorage.setItem(VIEWING_MONTH_KEY, JSON.stringify(period));
  } catch (error) {
    console.warn("Failed to save viewing period to localStorage:", error);
  }
};
